__webpack_require__.p = "/dev/572-karaoke-cursor/";